import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Design, Display, Pillar } from '@guardian/types';
import { RichLink } from '@root/src/web/components/RichLink';
export const DefaultRichLink = ({ index, headlineText, url, isPlaceholder, }) => {
    return (_jsx(RichLink, { richLinkIndex: index, cardStyle: "news", thumbnailUrl: "", headlineText: headlineText, contentType: "article", url: url, format: {
            display: Display.Standard,
            design: Design.Article,
            theme: Pillar.News,
        }, tags: [], sponsorName: "", isPlaceholder: isPlaceholder }, void 0));
};
